import { Loader2 } from 'lucide-react';
import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { useDashboardContext } from './DashboardContext';
import { formatTooltipMoney } from './helpers';

export const DepartmentBarChartCard: React.FC = () => {
  const { dashboard, loadingStates } = useDashboardContext();
  return (
    <div className="flex flex-col rounded-[22px] border border-slate-100 bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.02)] lg:col-span-2 h-[300px]">
      <h3 className="text-[13px] font-semibold text-slate-900">
        Department Performance
      </h3>
      <div
        className="mt-3 flex-1"
        style={{
          height: loadingStates.departments
            ? '100%'
            : Math.max(160, dashboard.departmentPerformance.length * 32),
        }}
      >
        {loadingStates.departments ? (
          <div className="flex h-full w-full items-center justify-center">
            <Loader2 className="animate-spin text-slate-300" size={24} />
          </div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={dashboard.departmentPerformance}
              layout="vertical"
              margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
            >
              <CartesianGrid stroke="#f1f5f9" horizontal={false} />
              <XAxis type="number" hide />
              <YAxis
                type="category"
                dataKey="department_name"
                axisLine={false}
                tickLine={false}
                tick={{ fill: '#64748b', fontSize: 10 }}
              />
              <Tooltip
                formatter={(value) => formatTooltipMoney(value)}
                cursor={{ fill: '#f8fafc' }}
                contentStyle={{
                  borderRadius: 8,
                  border: 'none',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
                }}
              />
              <Bar
                dataKey="total_sale"
                radius={[0, 8, 8, 0]}
                fill="#15803d"
                barSize={14}
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};
